import { useEffect } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export const CursorGlow = () => {
  const x = useMotionValue(-600);
  const y = useMotionValue(-600);
  const sx = useSpring(x, { stiffness: 55, damping: 16 });
  const sy = useSpring(y, { stiffness: 55, damping: 16 });

  useEffect(() => {
    const move = (e) => {
      x.set(e.clientX - 160);
      y.set(e.clientY - 160);
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  return (
    <motion.div
      data-testid="cursor-glow"
      className="cursor-glow pointer-events-none fixed left-0 top-0 z-[2] h-80 w-80 rounded-full orb-cursor will-change-transform"
      style={{ x: sx, y: sy }}
    />
  );
};
